<template>
  <div class="transaction-report">
    <div class="page-header">
      <h2>📊 گزارش تراکنش‌ها</h2>
      <p class="subtitle">مشاهده همه تراکنش‌های بیعانه و پرداخت‌های درگاه</p>
    </div>

    <!-- ========================================== -->
    <!-- آمار کلی -->
    <!-- ========================================== -->
    <div v-if="summary" class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon">💰</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_deposits) }}</span>
          <span class="stat-label">مجموع بیعانه‌ها</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">✅</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_deposits_paid) }}</span>
          <span class="stat-label">بیعانه پرداخت شده</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">⏳</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_deposits_pending) }}</span>
          <span class="stat-label">در انتظار پرداخت</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">🔄</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_deposits_refunded) }}</span>
          <span class="stat-label">عودت داده شده</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">💳</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_payments_paid / 10) }}</span>
          <span class="stat-label">مجموع پرداخت‌های درگاه</span>
        </div>
      </div>
      <!-- کیف پول -->
      <div class="stat-card">
        <div class="stat-icon">👛</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_wallet_balance) }}</span>
          <span class="stat-label">جمع موجودی کیف پول‌ها</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">👥</div>
        <div class="stat-content">
          <span class="stat-value">{{ summary.total_users_with_credit }}</span>
          <span class="stat-label">کاربران دارای کیف پول</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">📈</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.commission_total) }}</span>
          <span class="stat-label">کارمزد سیستم</span>

        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">📱</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_sms_amount) }}</span>
          <span class="stat-label">درآمد شارژ پیامک</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">📨</div>
        <div class="stat-content">
          <span class="stat-value">{{ get_currency(summary.total_sms_credits) }}</span>
          <span class="stat-label">کل پیامک‌های فروخته شده</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">✅</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_settled) }}</span>
          <span class="stat-label">جمع کل تسویه شده</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">⏳</div>
        <div class="stat-content">
          <span class="stat-value">{{ formatPrice(summary.total_unsettled) }}</span>
          <span class="stat-label">جمع کل تسویه نشده</span>
          <span class="stat-sub-label">
      (تسویه در انتظار: {{ formatPrice(summary.pending_settlements) }} +
      بیعانه تسویه نشده: {{ formatPrice(summary.unsettled_deposits) }})
    </span>
        </div>
      </div>


      <div class="stat-card">
        <div class="stat-icon">✅</div>
        <div class="stat-content">
          <span class="stat-value">{{
              formatPrice(
                  bank_amount
              )
            }}</span>
          <span class="stat-label">مانده بانک</span>
          <span class="stat-sub-label">
      (
            مانده واقعی:
            {{
              formatPrice(
                  real_bank_amount
              )
            }}

            )
    </span>
        </div>
      </div>


    </div>

    <!-- ========================================== -->
    <!-- فیلترها -->
    <!-- ========================================== -->
    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-group">
          <label>از تاریخ</label>
          <data-picker v-model="filters.date_from" type="date" class=""/>
        </div>
        <div class="filter-group">
          <label>تا تاریخ</label>
          <data-picker v-model="filters.date_to" type="date" class=""/>
        </div>
        <div class="filter-group">
          <label>وضعیت</label>
          <select v-model="filters.status" class="filter-select">
            <option value="">همه</option>
            <option value="pending">در انتظار</option>
            <option value="paid">پرداخت شده</option>
            <option value="failed">ناموفق</option>
            <option value="refunded">عودت داده شده</option>
          </select>
        </div>
        <button class="btn-filter" @click="loadReport">🔍 اعمال فیلتر</button>
        <button class="btn-reset" @click="resetFilters">⟳ پاک کردن</button>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- تب‌ها -->
    <!-- ========================================== -->
    <div class="tabs">
      <button
          :class="['tab-btn', { active: activeTab === 'deposits' }]"
          @click="activeTab = 'deposits'"
      >
        💰 تراکنش‌های بیعانه ({{ deposits.length }})
      </button>
      <button
          :class="['tab-btn', { active: activeTab === 'payments' }]"
          @click="activeTab = 'payments'"
      >
        💳 پرداخت‌های درگاه ({{ payments.length }})
      </button>
      <button
          :class="['tab-btn', { active: activeTab === 'sms' }]"
          @click="activeTab = 'sms'"
      >
        📱 تراکنش‌های پیامکی ({{ smsTransactions.length }})
      </button>
    </div>

    <!-- ========================================== -->
    <!-- لیست تراکنش‌های بیعانه -->
    <!-- ========================================== -->
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <span>در حال بارگذاری...</span>
    </div>

    <div v-else-if="activeTab === 'deposits'">
      <div v-if="deposits.length === 0" class="empty-state">
        <div class="empty-icon">📭</div>
        <h3>هیچ تراکنش بیعانه‌ای یافت نشد</h3>
      </div>

      <div v-else>
        <!-- دسکتاپ -->
        <div class="desktop-table">
          <table>
            <thead>
            <tr>
              <th>#</th>
              <th>سالن</th>
              <th>مشتری</th>
              <th>موبایل</th>
              <th>سفارش</th>
              <th>مبلغ</th>
              <th>وضعیت</th>
              <th>تاریخ پرداخت</th>
              <th>تسویه</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in deposits" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.market_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.user_mobile }}</td>
              <td>#{{ item.order_id }}</td>
              <td class="amount">{{ formatPrice(item.amount) }}</td>
              <td>
                  <span :class="['badge', statusClass(item.status)]">
                    {{ item.status_label }}
                  </span>
                <span v-if="item.refunded" class="badge badge-gray mr-1">عودت</span>
              </td>
              <td>{{ item.paid_at ? get_date_time(item.paid_at) : '-' }}</td>
              <td>
                <span v-if="item.settlement_id" class="badge badge-success">تسویه شده</span>
                <span v-else class="badge badge-warning">تسویه نشده</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- موبایل -->
        <div class="mobile-cards">
          <div v-for="(item, index) in deposits" :key="item.id" class="card-item">
            <div class="card-header">
              <span class="card-index">#{{ index + 1 }}</span>
              <span :class="['badge', statusClass(item.status)]">{{ item.status_label }}</span>
            </div>
            <div class="card-body">
              <div class="card-row"><span class="card-label">سالن:</span><span>{{ item.market_name }}</span></div>
              <div class="card-row"><span class="card-label">مشتری:</span><span>{{
                  item.user_name
                }} {{ item.user_mobile }}</span></div>
              <div class="card-row"><span class="card-label">مبلغ:</span><span
                  class="amount">{{ formatPrice(item.amount) }}</span></div>
              <div class="card-row"><span class="card-label">سفارش:</span><span>#{{ item.order_id }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- لیست پرداخت‌های درگاه -->
    <!-- ========================================== -->
    <div v-else-if="activeTab === 'payments'">
      <div v-if="summary" class="stats-grid">

        <div class="stat-card">
          <div class="stat-icon">✅</div>
          <div class="stat-content">
          <span class="stat-value">{{
              formatPrice(
                  calculate_items(payments.filter(x => x.status == 'paid'), 'amount')
              )
            }}</span>
            <span class="stat-label"> موفق</span>
            <span class="stat-sub-label">

            تعداد:
            {{
                formatPrice(
                    (payments.filter(x => x.status == 'paid').length)
                )
              }}
    </span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">✅</div>
          <div class="stat-content">
          <span class="stat-value">{{
              formatPrice(calculate_items(payments.filter(x => x.payable_type == 'deposit' && x.status == 'paid'), 'amount'))
            }}</span>
            <span class="stat-label">بیعانه</span>
            <span class="stat-sub-label">
            تعداد:
            {{formatPrice(payments.filter(x => x.payable_type == 'deposit' && x.status == 'paid').length)}}
            </span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">✅</div>
          <div class="stat-content">
          <span class="stat-value">{{
              formatPrice(calculate_items(payments.filter(x => x.payable_type == 'sms' && x.status == 'paid'), 'amount'))
            }}</span>
            <span class="stat-label">پیامک</span>
            <span class="stat-sub-label">
            تعداد:
            {{formatPrice(payments.filter(x => x.payable_type == 'sms' && x.status == 'paid').length)}}
            </span>
          </div>
        </div>      </div>
      <div v-if="payments.length === 0" class="empty-state">
        <div class="empty-icon">📭</div>
        <h3>هیچ پرداختی یافت نشد</h3>
      </div>

      <div v-else>
        <!-- دسکتاپ -->
        <div class="desktop-table">
          <table>
            <thead>
            <tr>
              <th>#</th>
              <th>سالن</th>
              <th>کاربر</th>
              <th>موبایل</th>
              <th>نوع</th>
              <th>مبلغ</th>
              <th>درگاه</th>
              <th>کد پیگیری</th>
              <th>شناسه تراکنش</th>
              <th>وضعیت</th>
              <th>تاریخ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in payments" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.market_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.user_mobile }}</td>
              <td>
                <span class="badge badge-info">{{ getPayableTypeLabel(item.payable_type) }}</span>
              </td>
              <td class="amount">{{ formatPrice(item.amount / 10) }}</td>
              <td>{{ item.gateway }}</td>
              <td>{{ item.ref_number || '-' }}</td>
              <td>{{ item.track_id || '-' }}</td>
              <td>
                <span :class="['badge', statusClass(item.status)]">{{ item.status_label }}</span>
              </td>
              <td>{{ get_date_time(item.created_at) }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- موبایل -->
        <div class="mobile-cards">
          <div v-for="(item, index) in payments" :key="item.id" class="card-item">
            <div class="card-header">
              <span class="card-index">#{{ index + 1 }}</span>
              <span :class="['badge', statusClass(item.status)]">{{ item.status_label }}</span>
            </div>
            <div class="card-body">
              <div class="card-row"><span class="card-label">سالن:</span><span>{{ item.market_name }}</span></div>
              <div class="card-row"><span class="card-label">مبلغ:</span><span
                  class="amount">{{ formatPrice(item.amount / 10) }}</span></div>
              <div class="card-row"><span class="card-label">کد پیگیری:</span><span>{{ item.ref_number || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- لیست تراکنش‌های پیامکی -->
    <!-- ========================================== -->
    <div v-else-if="activeTab === 'sms'">
      <div v-if="smsTransactions.length === 0" class="empty-state">
        <div class="empty-icon">📭</div>
        <h3>هیچ تراکنش پیامکی یافت نشد</h3>
      </div>

      <div v-else>
        <!-- دسکتاپ -->
        <div class="desktop-table">
          <table>
            <thead>
            <tr>
              <th>#</th>
              <th>سالن</th>
              <th>خریدار</th>
              <th>تعداد پیامک</th>
              <th>نرخ هر پیامک</th>
              <th>مبلغ پرداختی</th>
              <th>وضعیت</th>
              <th>تاریخ پرداخت</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in smsTransactions" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.market_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>
                <span class="sms-credits-badge">{{ get_currency(item.credits) }} 📨</span>
              </td>
              <td class="sms-ratio">{{ formatPrice(item.sms_ratio) }}</td>
              <td class="amount">{{ formatPrice(item.amount) }}</td>
              <td>
                <span :class="['badge', statusClass(item.status)]">{{ item.status_label }}</span>
              </td>
              <td>{{ item.paid_at ? get_date_time(item.paid_at) : '-' }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- موبایل -->
        <div class="mobile-cards">
          <div v-for="(item, index) in smsTransactions" :key="item.id" class="card-item">
            <div class="card-header">
              <span class="card-index">#{{ index + 1 }}</span>
              <span :class="['badge', statusClass(item.status)]">{{ item.status_label }}</span>
            </div>
            <div class="card-body">
              <div class="card-row"><span class="card-label">سالن:</span><span>{{ item.market_name }}</span></div>
              <div class="card-row"><span class="card-label">خریدار:</span><span>{{ item.user_name }}</span></div>
              <div class="card-row"><span class="card-label">تعداد:</span><span
                  class="sms-credits-badge">{{ get_currency(item.credits) }} 📨</span></div>
              <div class="card-row"><span class="card-label">مبلغ:</span><span
                  class="amount">{{ formatPrice(item.amount) }}</span></div>
              <div class="card-row"><span class="card-label">تاریخ:</span><span>{{
                  get_date_time(item.created_at)
                }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TransactionReport',

  data() {
    return {
      loading: false,
      activeTab: 'deposits',
      deposits: [],
      payments: [],
      smsTransactions: [],
      bank_amount: 0,
      real_bank_amount: 0,
      summary: null,
      filters: {
        date_from: '',
        date_to: '',
        status: '',
        market_id: ''
      }
    };
  },

  mounted() {
    this.loadReport();
  },

  methods: {
    async loadReport() {
      this.loading = true;
      try {
        const params = {
          date_from: this.filters.date_from || undefined,
          date_to: this.filters.date_to || undefined,
          status: this.filters.status || undefined,
          market_id: this.filters.market_id || undefined
        };

        const {data} = await axios.get('/api/super-admin/transactions/report', {params});

        this.deposits = data.deposits || [];
        this.payments = data.payments || [];
        this.smsTransactions = data.sms_transactions || []; // ✅ اضافه شد
        this.summary = data.summary || null;

        this.bank_amount = parseInt(this.summary.total_payments_paid / 10) - parseInt(this.summary.total_settled)
        this.real_bank_amount = parseInt(this.bank_amount - this.bank_amount * 0.011)

      } catch (error) {
        console.error('خطا:', error);
        this.$message?.error('خطا در بارگذاری گزارش');
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.filters = {date_from: '', date_to: '', status: '', market_id: ''};
      this.loadReport();
    },

    formatPrice(value) {
      if (!value) return '۰';
      return new Intl.NumberFormat('fa-IR').format(parseFloat(value)) + ' تومان';
    },


    statusClass(status) {
      const map = {
        pending: 'badge-warning',
        paid: 'badge-success',
        failed: 'badge-danger',
        refunded: 'badge-gray'
      };
      return map[status] || 'badge-gray';
    },

    getPayableTypeLabel(type) {
      const map = {
        deposit: 'بیعانه',
        sms: 'شارژ پیامک',
        subscription: 'اشتراک'
      };
      return map[type] || type;
    }
  }
};
</script>

<style scoped>
.transaction-report {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  direction: rtl;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
}

.subtitle {
  margin: 4px 0 0 0;
  color: #909399;
  font-size: 14px;
}

/* ===== آمار ===== */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 14px;
}

.stat-icon {
  font-size: 28px;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-value {
  font-size: 16px;
  font-weight: bold;
  color: #2c3e50;
}

.stat-label {
  font-size: 12px;
  color: #909399;
}

/* ===== فیلترها ===== */
.filter-section {
  background: white;
  padding: 16px 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-group label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.filter-input,
.filter-select {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 13px;
  background: white;
}

.btn-filter {
  padding: 6px 20px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.btn-filter:hover {
  background: #66b1ff;
}

.btn-reset {
  padding: 6px 16px;
  background: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

/* ===== تب‌ها ===== */
.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  background: #f5f7fa;
  padding: 6px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;
  font-weight: 500;
}

.tab-btn:hover {
  background: #e8f0fe;
}

.tab-btn.active {
  background: white;
  color: #409eff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* ===== جدول ===== */
.desktop-table {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  overflow-x: auto;
}

.desktop-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 900px;
}

.desktop-table thead th {
  background: #f5f7fa;
  color: #606266;
  font-weight: 600;
  padding: 12px 14px;
  text-align: right;
  border-bottom: 2px solid #e4e7ed;
}

.desktop-table tbody td {
  padding: 10px 14px;
  border-bottom: 1px solid #ebeef5;
  color: #303133;
}

.desktop-table tbody tr:hover td {
  background: #f5f7fa;
}

.amount {
  font-weight: 600;
  color: #2c3e50;
}

/* ===== بج‌ها ===== */
.badge {
  display: inline-block;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.badge-success {
  background: #f0f9eb;
  color: #67c23a;
}

.badge-warning {
  background: #fdf6ec;
  color: #e6a23c;
}

.badge-danger {
  background: #fef0f0;
  color: #f56c6c;
}

.badge-info {
  background: #ecf5ff;
  color: #409eff;
}

.badge-gray {
  background: #f4f4f5;
  color: #909399;
}

/* ===== حالت‌ها ===== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  color: #909399;
  gap: 12px;
  background: white;
  border-radius: 10px;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 10px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

/* ===== کارت‌های موبایل ===== */
.mobile-cards {
  display: none;
}

.card-item {
  background: white;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.card-index {
  font-weight: 600;
  color: #909399;
  font-size: 13px;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.card-row {
  display: flex;
  gap: 6px;
  font-size: 13px;
  color: #303133;
  flex-wrap: wrap;
}

.card-label {
  font-weight: 500;
  color: #909399;
  min-width: 60px;
}

/* ===== ریسپانسیو ===== */
@media (max-width: 768px) {
  .transaction-report {
    padding: 12px;
  }

  .filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-input,
  .filter-select {
    width: 100%;
  }

  .btn-filter,
  .btn-reset {
    width: 100%;
    text-align: center;
  }

  .desktop-table {
    display: none;
  }

  .mobile-cards {
    display: block;
  }

  .stats-grid {
    grid-template-columns: 1fr 1fr;
  }
}

/* ===== بج تعداد پیامک ===== */
.sms-credits-badge {
  display: inline-block;
  padding: 3px 12px;
  background: #ecf5ff;
  color: #409eff;
  border-radius: 12px;
  font-weight: 700;
  font-size: 12px;
}

.sms-ratio {
  font-size: 12px;
  color: #909399;
}

.stat-sub-label {
  font-size: 10px;
  color: #c0c4cc;
  margin-top: 2px;
  line-height: 1.4;
}
</style>